export default __webpack_public_path__ + "static/media/Oppo.b48d5236.svg";